import React from "react";
import { Link } from "react-router-dom";
import "./AboutPage.css";
import { useLanguage } from "../shared/LanguageContext";

function AboutPage() {
  const { language, t } = useLanguage();
  const isSpanish = language === "es";
  const paymentLink = isSpanish
    ? process.env.REACT_APP_STRIPE_PAYMENT_LINK_ES
    : process.env.REACT_APP_STRIPE_PAYMENT_LINK;
  return (
    <main className="aur-about-page" data-testid="aur-about-page">
      <div className="aur-about-page__container">
        <img
          src={isSpanish ? "/aur-book/aur-about-es.jpg" : "/aur-book/aur-about.png"}
          alt={isSpanish ? "Acerca de AUR — El Espejo de la Mente" : "About AUR — The Mirror of the Mind"}
          className="mirror-about-artwork"
          draggable="false"
        />

        {/* TOP NAVIGATION */}
        <Link
          to="/mirror-of-the-mind"
          className="aur-about-page__overlay"
          data-testid="about-nav-home"
          aria-label={t("home")}
          style={isSpanish ? { top: "1.1%", left: "29.0%", width: "5.2%", height: "1.5%" } : { top: "0.85%", left: "22.8%", width: "6.0%", height: "1.7%" }}
        />

        <Link to="/legal/terms" className="aur-about-page__overlay" data-testid="about-footer-terms" aria-label={isSpanish ? "Términos de uso" : "Terms of Use"} style={isSpanish ? { top: "94.3%", left: "24.4%", width: "8.8%", height: "1.5%" } : { top: "94.3%", left: "26.4%", width: "7.5%", height: "1.5%" }} />
        <Link to="/legal/privacy" className="aur-about-page__overlay" data-testid="about-footer-privacy" aria-label={isSpanish ? "Privacidad" : "Privacy"} style={isSpanish ? { top: "94.3%", left: "35.6%", width: "5.3%", height: "1.5%" } : { top: "94.3%", left: "36.1%", width: "4.1%", height: "1.5%" }} />
        <Link to="/legal/digital-product-information" className="aur-about-page__overlay" data-testid="about-footer-digital-product-info" aria-label={isSpanish ? "Información del producto digital" : "Digital Product Information"} style={isSpanish ? { top: "94.3%", left: "43.6%", width: "16.9%", height: "1.5%" } : { top: "94.3%", left: "42.2%", width: "15.0%", height: "1.5%" }} />
        <Link to="/legal/copyright" className="aur-about-page__overlay" data-testid="about-footer-copyright" aria-label="Copyright" style={isSpanish ? { top: "94.3%", left: "62.5%", width: "5.5%", height: "1.5%" } : { top: "94.3%", left: "59.5%", width: "5.8%", height: "1.5%" }} />
        <Link to="/legal/contact" className="aur-about-page__overlay" data-testid="about-footer-contact-support" aria-label={isSpanish ? "Contacto / Soporte" : "Contact / Support"} style={isSpanish ? { top: "94.3%", left: "70.9%", width: "10.3%", height: "1.5%" } : { top: "94.3%", left: "67.7%", width: "10.5%", height: "1.5%" }} />
        <Link
          to="/mirror-of-the-mind/about"
          className="aur-about-page__overlay"
          data-testid="about-nav-about"
          aria-label={t("about")}
          style={isSpanish ? { top: "1.1%", left: "36.1%", width: "8.0%", height: "1.5%" } : { top: "0.85%", left: "29.3%", width: "5.9%", height: "1.7%" }}
        />
        <Link
          to="/mirror-of-the-mind/book"
          className="aur-about-page__overlay"
          data-testid="about-nav-preview"
          aria-label={t("preview")}
          style={isSpanish ? { top: "1.1%", left: "45.7%", width: "10.2%", height: "1.5%" } : { top: "0.85%", left: "36.9%", width: "7.2%", height: "1.7%" }}
        />
        <Link
          to="/mirror-of-the-mind/book/product"
          className="aur-about-page__overlay"
          data-testid="about-nav-product-info"
          aria-label={t("productInfo")}
          style={isSpanish ? { top: "1.1%", left: "56.2%", width: "17.8%", height: "1.5%" } : { top: "0.85%", left: "45.6%", width: "12.1%", height: "1.7%" }}
        />
        <Link
          to="/legal/contact"
          className="aur-about-page__overlay"
          data-testid="about-nav-support"
          aria-label={t("support")}
          style={isSpanish ? { top: "1.1%", left: "76.2%", width: "7.4%", height: "1.5%" } : { top: "0.85%", left: "59.7%", width: "7.0%", height: "1.7%" }}
        />
        <a
          href={paymentLink}
          target="_blank"
          rel="noopener noreferrer"
          className="aur-about-page__overlay"
          data-testid="about-nav-purchase"
          aria-label={t("purchase")}
          style={isSpanish ? { top: "0.7%", left: "84.7%", width: "14.0%", height: "3.2%" } : { top: "0.85%", left: "68.8%", width: "9.0%", height: "1.7%" }}
        />

        {!isSpanish && (
          <Link
            to="/mirror-of-the-mind/book"
            className="aur-about-page__overlay"
            data-testid="about-nav-view-the-book"
            aria-label={t("viewBook")}
            style={{ top: "0.35%", left: "81.4%", width: "16.0%", height: "3.4%" }}
          />
        )}

        {/* FINAL CALL TO ACTION */}
        <Link
          to="/mirror-of-the-mind/book"
          className="aur-about-page__overlay"
          data-testid="about-view-the-book"
          aria-label={t("viewBook")}
          style={isSpanish ? { top: "85.9%", left: "36.0%", width: "28.0%", height: "3.5%" } : { top: "85.2%", left: "35.3%", width: "30.8%", height: "3.5%" }}
        />
      </div>
    </main>
  );
}

export default AboutPage;
